// extracted by mini-css-extract-plugin
module.exports = {"cursor":"Cursor_cursor__1aswT","videoIcon":"Cursor_videoIcon__ikqmw","videoLabel":"Cursor_videoLabel__L8dVe"};